export enum SubscriptionMigrationTypeEnum {
    Upgrade, Downgrade, Current
}
